import { Component, OnInit } from '@angular/core';
import { SeoService } from '../core/service/seo.service';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css'],
})
export class PrivacyPolicyComponent implements OnInit {
  constructor(private seoService: SeoService) {}

  ngOnInit(): void {
    this.seoService.updateMetaTag(
      'description',
      'Die Datenschutzerklärung beschreibt, wie Daten (insbesondere personenbezogene Daten) von ACA BJJ verarbeitet werden.',
    );
    this.seoService.createLinkForCanonicalURL('/privacy-policy');
  }
}
